import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class ItemCodeRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    itemCode: number;
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    unitId?: number;

}